import Fernet from 'fernet-web';

let fernetPromise: Promise<Fernet> | null = null;

function getFernetInstance(): Promise<Fernet> {
  const key = process.env.REACT_APP_API_ENCRYPTION_KEY;
  if (!key) {
    throw new Error(
      "REACT_APP_API_ENCRYPTION_KEY is missing. Check .env and restart the React development server."
    );
  }

  if (!fernetPromise) {
    fernetPromise = Fernet.create(key);
  }
  return fernetPromise;
}

/**
 * Decrypts a Fernet-encrypted API response payload asynchronously.
 * Expected payload: { encrypted_data: "gAAAAAB..." }
 */
export async function decryptResponse(payload: any): Promise<any> {
  if (!payload) return payload;

  // Extract the encrypted data
  const cipherText = payload.encrypted_data;
  
  if (!cipherText || typeof cipherText !== 'string') {
    // If not encrypted, or doesn't match the expected structure, return as is.
    return payload;
  }

  try {
    const fernet = await getFernetInstance();
    const decryptedString = await fernet.decrypt(cipherText);
    
    if (!decryptedString) {
      throw new Error("Fernet decryption returned an empty string.");
    }
    
    return JSON.parse(decryptedString);
  } catch (error) {
    // Log the error clearly but do not expose sensitive data
    console.error("[Decryption Error] Failed to decrypt Fernet API response:", error);
    // Return original payload on failure so it can fail gracefully
    return payload;
  }
}
